import type { FC } from 'react';
import { Dialog, Box } from '@mui/material';

interface IProps {
  open: boolean;
  handleClose: () => void;
  selectedImageItem: MAIN_CONTAINER.ImageCodeItem;
  type: 'small' | 'large';
}

const ImageDialog: FC<IProps> = ({
  open,
  handleClose,
  selectedImageItem,
  type,
}) => {
  return (
    <Dialog open={open} onClose={handleClose}>
      <Box sx={{ borderRadius: '8px', m: 2 }}>
        {type === 'small' ? (
          <Box
            component="img"
            src={selectedImageItem?.codeUrl}
            alt=""
            style={{ width: 148, height: 148, flex: 'none' }}
            width={{
              xs: 148,
              sx: 168,
              md: 200,
            }}
            height={{
              xs: 148,
              sx: 168,
              md: 200,
            }}
          />
        ) : (
          <Box
            component="img"
            src={selectedImageItem?.codeUrl}
            alt=""
            style={{ width: 248, height: 248, flex: 'none' }}
            width={248}
            height={248}
          />
        )}
      </Box>
    </Dialog>
  );
};

export default ImageDialog;
